import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import { Layout, Menu, Button } from 'antd';
import Login from './pages/Login';
import OrderList from './pages/OrderList';
import PlaceOrder from './pages/PlaceOrder';
import { AuthProvider, useAuth } from './contexts/AuthContext';

const { Header, Content } = Layout;

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppLayout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const menuItems = [
    {
      key: '/place-order',
      label: <Link to="/place-order">下单</Link>
    },
    {
      key: '/order-list',
      label: <Link to="/order-list">订单列表</Link>
    }
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ padding: '0 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={menuItems}
          style={{ 
            flex: 1, 
            minWidth: 0, 
            border: 'none',
            background: 'transparent',
            color: '#fff'
          }}
          theme="dark"
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span style={{ color: '#fff' }}>
            剩余API额度: {user?.api_quota || 0}
          </span>
          <span style={{ color: '#fff' }}>
            {user?.username}
          </span>
          <Button 
            type="link" 
            onClick={logout} 
            style={{ color: '#fff', padding: 0 }}
          >
            退出
          </Button>
        </div>
      </Header>
      <Layout style={{ padding: '24px' }}>
        <Content style={{ background: '#fff', padding: 24, margin: 0, minHeight: 280 }}>
          <Routes>
            <Route path="/place-order" element={<PlaceOrder />} />
            <Route path="/order-list" element={<OrderList />} />
            <Route path="/" element={<Navigate to="/place-order" />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <AppLayout />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;